import { Icons } from '@commenda/kakashi';

import { ServiceAuditorDisplayStatus } from '@commenda/api/agent-platform/service-auditor/types';
import { TaskStatus } from '@prisma/client';

import { ServiceRequestTaskIconConfig } from '../../common/taskIconConfig';
import { ServiceAuditRunStatusHelper } from '../helpers/ServiceAuditRunStatusHelper';

interface IServiceAuditTaskStatusIconProps {
  // Null before any audit, and for anyone who may not see the audit.
  auditStatus: ServiceAuditorDisplayStatus | null;
  taskStatus: TaskStatus;
}

// A failed audit never shows the green completed tick, even on a finished step.
export const ServiceAuditTaskStatusIcon = ({
  auditStatus,
  taskStatus,
}: IServiceAuditTaskStatusIconProps) => {
  if (auditStatus === ServiceAuditorDisplayStatus.FAILED) {
    return (
      <div className="mr-md flex size-6 items-center justify-center rounded-md bg-bg-error">
        <Icons.XCircle className="size-4 text-text-error" />
      </div>
    );
  }
  return ServiceRequestTaskIconConfig[
    ServiceAuditRunStatusHelper.getAuditTaskStatus(auditStatus, taskStatus)
  ];
};
